module.exports = __webpack_public_path__ + "img/animal_festa_hero.eb7da626.jpg";